import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { canAccessPlatformHub } from "@/navigation/platform-access";
import { routes } from "@/router/all_routes";

interface PlatformHubRouteProps {
  children: ReactNode;
}

export function PlatformHubRoute({ children }: PlatformHubRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="suite-center-message">
        <p className="text-muted mb-0">Chargement…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.login} replace />;
  }

  if (!canAccessPlatformHub(user)) {
    return <Navigate to={routes.accessDenied} replace />;
  }

  return children;
}
